export default function StripTags(str) {
  return !str ?
    '' :
    str.replace(/<\/?[^>]+>/g, '');
}
